import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";
import { mapEntityResponse } from "@/redux/mappers/Export/CreateNewJob/EntityMappers";

export const entityApi = createApi({
  reducerPath: "entityApi",
  baseQuery,
  tagTypes: ["Entity"],
  endpoints: (builder) => ({
    getEntityByMasterId: builder.query({
      query: ({id}) => `export/entity/${id}`,
      transformResponse: (response) => {
        const data = response?.data.map(mapEntityResponse) ;
        return data
      },
      providesTags: ["Entity"],
    }),
    
    // 🔄 UPDATE entity
    updateEntity: builder.mutation({
      query: ({ id, subId, ...data }) => ({
        url: `export/entity/${id}/${subId}`,
        method: "PUT",
        headers: { "X-Request-Id": Math.random().toString(36).substring(2) },
        body: { entity: data }, 

      }),
      invalidatesTags: ["Entity"],
    }),

    // 🔄 DELETE entity
    deleteEntity: builder.mutation({
      query: ({ id }) => ({
        url: `export/entity/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Entity"],
    }),

    // 🔄 CREATE entity
    createEntity: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `export/entity/${id}`,
        method: "PUT", // ✅ API requires PUT
        headers: { "X-Request-Id": Math.random().toString(36).substring(2) },
        body: { entity: data }, 
      }),
      invalidatesTags: ["Entity"],
    }),
  }),
});

export const {
  useGetEntityByMasterIdQuery,
  useLazyGetEntityByMasterIdQuery,
  useUpdateEntityMutation,
  useDeleteEntityMutation, // ✅ added
  useCreateEntityMutation, // ✅ added
} = entityApi;

